export const formatPrice = (price: string) => {
  const [pounds, pence] = price.split(".")
  if (Number(pence) === 0) return String(pounds)
  return price
}
